import { render, staticRenderFns } from "./message_rule_dialog.vue?vue&type=template&id=c9538812"
import script from "./message_rule_dialog.vue?vue&type=script&lang=js"
export * from "./message_rule_dialog.vue?vue&type=script&lang=js"
import style0 from "./message_rule_dialog.vue?vue&type=style&index=0&id=c9538812&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports